var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",staticClass:"app-map-frame"},[_c('img',{staticClass:"map-layer",attrs:{"src":_vm.mapImageSource}}),_c('img',{staticClass:"map-marker",attrs:{"src":`/images/${_vm.markerIcon}.svg`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }